export const parseIbgeStatesToOptions = states => states
    .map(state => ({ label: state.name, value: state.stateCode }));

export const parseIbgeCitiesToOptions = cities => cities
    .map(city => ({ label: city.name, value: city.id }));
